import './Box.css';

export default function Box(props) {
    return (
        <div className="white-box">{props.children}</div>
    );
}